import api from '../../plugins/api';

//проверить статус заявки в банке (временно, в будущем должны вызывать наш хук и передавать статус сами)
const checkBankStatus = ({ chunkId, bankId }) => {
  return api.get('/api/bank/checkStatusAppeal', { chunkId, bankId });
};

export default checkBankStatus;
